import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import formatValue from 'scoreboard/components/format-value'
import reportConstants from 'scoreboard/reports/report-constants'

function show(el, reportModel, meta = {}, hasCustomWarnings) {
	let warnings = [].concat(reportModel.warnings())

	// the backend will limit the results property to 10,000 if there are
	// more records than that so we need to check if numResults is equal to
	// MAX_RESULTS which will indicate that the records were limited
	if (meta.numResults >= reportConstants.MAX_RESULTS || meta.maxResultsReturned) {
		warnings.push(i18n.get('report.customReport.warn.maxResults',
			formatValue({value: reportConstants.MAX_RESULTS, shorten: false})))
		if (reportModel.isGrouping() && reportModel.isShowingIndividualRecords()) {
			warnings.push(i18n.get('report.designer.groupingWithTooManyResults'))
		}
	}
	if (meta.error) {
		warnings.push(meta.error)
	}
	let banner = el.find('.banner.banner-warning')

	// If errors are being passed from another view, display the banner but
	// don't empty it.
	if (hasCustomWarnings) {
		banner.removeClass('is-not-displayed')
		return
	}

	if (!_.isEmpty(warnings)) {
		banner.removeClass('is-not-displayed banner-error')
			.empty()
		_.each(warnings, warning => {banner.append(`<div>${warning}</div>`)})
	} else {
		banner.addClass('is-not-displayed')
	}
}

export { show }